interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
}

export const CustomModal = ({ isOpen, onClose, onDelete }: ModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-200 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-100">
        <h2 className="text-xl font-semibold text-center mb-2">
          Are you sure?
        </h2>
        <p className="text-center mb-3">Do you want to delete this item?</p>
        <div className="flex items-center justify-center gap-6">
          <button
            onClick={onClose}
            className="px-4 py-2 text-black rounded border hover:bg-gray-200"
          >
            Cancel
          </button>
          <button
            onClick={onDelete}
            className="bg-teal-500 text-white px-6 py-2 rounded hover:bg-teal-600"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};
